"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonBone = void 0;
var SkeletonBone;
(function (SkeletonBone) {
    SkeletonBone[SkeletonBone["NONE"] = 0] = "NONE";
    SkeletonBone[SkeletonBone["HEAD"] = 1] = "HEAD";
    SkeletonBone[SkeletonBone["NECK"] = 2] = "NECK";
    SkeletonBone[SkeletonBone["CHEST"] = 3] = "CHEST";
    SkeletonBone[SkeletonBone["CHEST_OFFSET"] = 4] = "CHEST_OFFSET";
    SkeletonBone[SkeletonBone["WAIST"] = 5] = "WAIST";
    SkeletonBone[SkeletonBone["HIP"] = 6] = "HIP";
    SkeletonBone[SkeletonBone["HIP_OFFSET"] = 7] = "HIP_OFFSET";
    SkeletonBone[SkeletonBone["HIPS_WIDTH"] = 8] = "HIPS_WIDTH";
    SkeletonBone[SkeletonBone["UPPER_LEG"] = 9] = "UPPER_LEG";
    SkeletonBone[SkeletonBone["LOWER_LEG"] = 10] = "LOWER_LEG";
    SkeletonBone[SkeletonBone["FOOT_LENGTH"] = 11] = "FOOT_LENGTH";
    SkeletonBone[SkeletonBone["FOOT_SHIFT"] = 12] = "FOOT_SHIFT";
    SkeletonBone[SkeletonBone["SKELETON_OFFSET"] = 13] = "SKELETON_OFFSET";
    SkeletonBone[SkeletonBone["SHOULDERS_DISTANCE"] = 14] = "SHOULDERS_DISTANCE";
    SkeletonBone[SkeletonBone["SHOULDERS_WIDTH"] = 15] = "SHOULDERS_WIDTH";
    SkeletonBone[SkeletonBone["UPPER_ARM"] = 16] = "UPPER_ARM";
    SkeletonBone[SkeletonBone["LOWER_ARM"] = 17] = "LOWER_ARM";
    SkeletonBone[SkeletonBone["HAND_Y"] = 18] = "HAND_Y";
    SkeletonBone[SkeletonBone["HAND_Z"] = 19] = "HAND_Z";
    SkeletonBone[SkeletonBone["ELBOW_OFFSET"] = 20] = "ELBOW_OFFSET";
    SkeletonBone[SkeletonBone["UPPER_CHEST"] = 21] = "UPPER_CHEST";
})(SkeletonBone = exports.SkeletonBone || (exports.SkeletonBone = {}));
